<template>
  <Card>
    <span slot="title">菜单管理</span>
    <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getMenusData)" class="fr">刷新</el-button>
    <div slot="content" class="menuwrap">
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addMenu">新增菜单</el-button>
      </div>
      <!-- 菜单列表 -->
      <el-table v-loading="loading" :data="menuList" :max-height="tableHeight" row-key="menuId" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" border>
        <el-table-column v-for="item in columns" :prop="item.dataIndex" :label="item.text"
        :key="item.dataIndex" :min-width="item.minWidth" :fixed="item.fixed"/>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" @click="addMenu(scope.row)" icon="el-icon-plus" :disabled="scope.row.btnFlag">新增</el-button>
            <el-button @click="editMenu(scope.row)" icon="el-icon-edit">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="menuEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="470px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="上级菜单" prop="parentId">
            <el-select v-model="editForm.parentId" placeholder="请选择上级菜单">
              <el-option v-for="item in superMenuOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="菜单类型" prop="menuType">
            <el-radio-group v-model="editForm.menuType" @change="menuTypeChange" >
              <el-radio :label="'M'">目录</el-radio>
              <el-radio :label="'C'">菜单</el-radio>
              <!-- <el-radio :label="'F'">按钮</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <el-form-item label="菜单名称" prop="menuName">
            <el-input v-model="editForm.menuName" placeholder="请输入菜单名称"/>
          </el-form-item>
          <el-form-item label="组件路径" prop="component" v-if="editForm.menuType == 'M' || editForm.menuType == 'C'">
            <el-input v-model="editForm.component" placeholder="请输入菜单组件路径" />
          </el-form-item>
          <el-form-item label="显示顺序" prop="orderNum">
            <el-input  v-model.number="editForm.orderNum" placeholder="请输入菜单显示顺序"/>
          </el-form-item>
          <el-form-item label="菜单图标" prop="icon">
            <el-input v-model="editForm.icon" placeholder="请输入菜单图标类名" />
          </el-form-item>
          <el-form-item label="菜单状态" prop="status" v-if="editForm.menuType == 'M' || editForm.menuType == 'C'">
            <el-radio-group v-model="editForm.status">
              <el-radio :label="0">显示</el-radio>
              <el-radio :label="1">隐藏</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增菜单'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑菜单'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </Card>
</template>

<script lang="js">
import { menuList, menuAdd, menuEdit } from "@/api/menu"; // 获取菜单请求
export default {
  name: "Menu",
  data() {
    return {
      loading: true, // 加载中
      flag: false, // 是否可以操作
      menuList: [], //菜单列表
      superMenuOptions: [{ label: "主目录", value: 0}], // 上级菜单选项
      orderSuper: [], // 菜单上级菜单
      // btnSuper: [], // 按钮上级菜单
      statusOptions: [ // 状态选项
        { itemLabel: "显示", itemValue: 0 },
        { itemLabel: "隐藏", itemValue: 1 },
      ], // 菜单状态选项
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 编辑获取修改数据
      columns: [
        { dataIndex: 'menuName', text: '菜单名称', minWidth: 150, fixed: 'left' },
        { dataIndex: 'orderNum', text: '显示顺序', minWidth: null, fixed: null },
        { dataIndex: 'icon', text: '图标类名', minWidth: 160, fixed: null },
        { dataIndex: 'component', text: '组件路径', minWidth: 260, fixed: null },
        { dataIndex: 'menuType', text: '菜单类型', minWidth: null, fixed: null },
        { dataIndex: 'status', text: '是否显示', minWidth: null, fixed: null },
        { dataIndex: 'createTime', text: '创建时间', minWidth: 160, fixed: null },
      ], // 表格列
      editFormRules: {
        parentId:[{ required: true, message: "请选择上级菜单", trigger: 'change'}],
        menuType:[{ required: true, message: "请选择菜单类型", trigger: 'change'}],
        menuName:[{ required: true, message: "请输入菜单名称", trigger: 'blur'}],
        component:[{ required: true, message: "请输入菜单组件路径", trigger: 'blur'}],
        perms:[{ required: true, message: "请输入菜单组件地址", trigger: 'blur'}],
        orderNum:[{ required: true, message: "请输入菜单显示顺序"}, { type: 'number', message: '菜单顺序必须是数字值'}],
        icon:[{ required: true, message: "请输入菜单图标类名", trigger: 'blur'}],
        status:[{ required: true, message: "请选择菜单显示或者隐藏", trigger: 'change'}],
      }, // 表单验证规则
      tableHeight: null, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 180;
    this.$forceUpdate();
    this.getMenusData();// 获取菜单列表
  },
  methods: {
    // 请求所有菜单列表
    async getMenusData() {
      let { data, code } = await menuList();
      if (code == 200) {
        if (data.length > 0) {
          this.orderSuper = [],/*  this.btnSuper = [], */ this.menuList = [];
          data.forEach(item => {
            item.orderNum = Number(item.orderNum);
            item.status == 0 ? item.status = "显示" : item.status = "隐藏";
            if (item.menuType == "M") {
              this.orderSuper.push({ label: item.menuName, value: item.menuId });
              item.menuType = "目录";
              item.btnFlag = false;
            } else if (item.menuType == "C") {
              // this.btnSuper.push({ label: item.menuName, value: item.menuId });
              item.menuType = "菜单";
              item.btnFlag = true;
            } /* else if (item.menuType == "F") {
              item.menuType = "按钮";
              item.btnFlag = true;
              delete item.status;
            } */
          });
        }
        this.listToTree(data);
      }
      this.loading = false;
    },
    // 链式结构转树形结构
    listToTree(list) {
      this.menuList = [];
      // 目录列表
      list.forEach(item => { if (item.menuType == "目录") this.menuList.push(item) });
      // 菜单列表
      list.forEach(item => {
        if (item.menuType == "菜单") this.menuList.forEach(items => { if (item.parentId == items.menuId) items.children.push(item) });
      });
      // 按钮列表
      // list.forEach(item => {
      //   if (item.menuType == "按钮") {
      //     this.menuList.forEach(items => {
      //       items.children.forEach(itemm => { if (item.parentId == itemm.menuId) itemm.children.push(item) });
      //     })
      //   }
      // });
    },
    // 新增菜单
    addMenu(row) {
      // 值转换 及 上级目录表切换
      if (row) {
        let obj = JSON.parse(JSON.stringify(row));
        switch (obj.menuType) {
          case "目录": obj.menuType = "C"; this.superMenuOptions = this.orderSuper; break;
          case "菜单": obj.menuType = "F"; /* this.superMenuOptions = this.btnSuper; break; */
          // case "按钮": break;
        }
        obj.parentId = obj.menuId;
        this.editForm = { parentId: obj.parentId, menuType: obj.menuType, menuName: null, component: null, perms: null, orderNum: null, icon: null, status: 0 };
        this.flag = true;
      } else {
        this.flag = false;
        this.editForm = { parentId: null, menuType: 'M', menuName: null, component: null, perms: null, orderNum: null, icon: null, status: 0 };
      }

      this.dialogVisible = true;
      this.dialogTitle = "新增菜单";
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          let params = this.editForm;
          this.superMenuOptions.forEach(item => {
            if (params.parentName == item.label) params.parentId = item.value;
          });
          menuAdd(params).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("创建菜单成功！");

            this.flag = false;
            this.dialogVisible = false;
            this.$refresh(this.getMenusData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 修改菜单
    editMenu(row) {
      let obj = JSON.parse(JSON.stringify(row));
      // 值转换 及 上级目录表切换
      switch (obj.menuType) {
        case "目录": obj.menuType = "M"; this.superMenuOptions = [{ label: "主目录", value: 0}]; break;
        case "菜单": obj.menuType = "C"; this.superMenuOptions = this.orderSuper; break;
        // case "按钮": obj.menuType = "F"; this.superMenuOptions = this.btnSuper; break;
      }
      obj.status == "显示" ? obj.status = 0 : obj.status = 1;
      this.editForm = obj;

      this.flag = true;
      this.dialogVisible = true;
      this.dialogTitle = "编辑菜单";
    },
    // 保存修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          menuEdit(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("修改菜单信息成功！");

            this.dialogVisible = false;
            this.flag = false;
            this.$refresh(this.getMenusData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 切换菜单类型
    menuTypeChange(val) {
      switch (val) {
        case "M": this.superMenuOptions = [{ label: "主目录", value: 0}]; break;
        case "C": this.superMenuOptions = this.orderSuper; break;
        // case "F": this.superMenuOptions = this.btnSuper; break;
        default: this.superMenuOptions = [{ label: "主目录", value: 0}]; break;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.menuwrap {
  width: 100%;
  height: 100%;
  .menuEdit {
    .el-form-item {
      width: 100%;
      margin-right: 0;
    }
    /deep/.el-input {
      width: 350px;
    }
  }
  & > div:not(:last-child) {
    margin-bottom: 20px;
  }
}
</style>